import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import TimeoutUtility from "../../contexts/TimeoutUtility";
import { validateField } from "../../contexts/Utils";
import {
  GridComponent,
  ColumnsDirective,
  ColumnDirective,
  Inject,
  Sort,
  Resize,
} from "@syncfusion/ej2-react-grids";
import { addJournalApi, getAccList } from "../../api";
import { Header, Button } from "../../components";
import { useStateContext } from "../../contexts/ContextProvider";
import "../../styles/AddPart.css";
import { Container, Col, Row } from "react-bootstrap";
import TextAreaField from "../../components/TextAreaField";
import DoubleField from "../../components/DoubleField";
import SelectField from "../../components/SelectField";
import { showSuccessToast, showErrorToast } from "../../components/ToastMesg";

const AddJournal = () => {
  const navigate = useNavigate();
  const { storeG } = useStateContext();
  const [Journals, setJournals] = useState([]);
  const [Accounts, setAccounts] = useState([]);
  const [Types, setTypes] = useState([]);
  const [formData, setFormData] = useState({
    account: "select",
    type: "select",
    amount: "0.0",
    notes: "",
  });
  const [errors, setErrors] = useState({});
  const [loadBtn, setLoadBtn] = useState(false);

  const creditCol = (props) => (
    <div>{props.type_id === 902 ? formatCurrency(props.amount) : `-`}</div>
  );
  const debitCol = (props) => (
    <div>{props.type_id === 901 ? formatCurrency(props.amount) : `-`}</div>
  );

  const customersGrid = [
    {
      field: "account",
      headerText: "Account",
      width: "110",
      textAlign: "left",
    },
    {
      headerText: "Credit",
      template: creditCol,
      width: "100",
      textAlign: "right",
    },
    {
      headerText: "Debit",
      template: debitCol,
      width: "100",
      textAlign: "right",
    },
    {
      field: "note",
      headerText: "Note",
      width: "200",
      textAlign: "left",
    },
  ];

  const handleRowSelected = (args) => {
    TimeoutUtility.resetTimeout();
    if (window.confirm(`Do you want to remove this ledger from the Journal?`)) {
      const updatedAccounts = [...Journals];
      updatedAccounts.splice(args.rowIndex, 1);
      setJournals([...updatedAccounts]);
    }
  };

  const formatCurrency = (number) => {
    return number.toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 2,
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    const error = validateField(name, value, name);
    setErrors((prev) => ({ ...prev, [name]: error }));
  };

  const handleSelectChange = (option, e) => {
    if (option && option.value) {
      setFormData((prev) => ({ ...prev, [e.name]: option }));
      const error = validateField(e.name, option, e.name);
      setErrors((prev) => ({ ...prev, [e.name]: error }));
    } else setFormData((prev) => ({ ...prev, [e.name]: "select" }));
  };

  const handleBackClick = () => {
    TimeoutUtility.resetTimeout();
    navigate("/Journal");
  };

  const handleAddItem = () => {
    TimeoutUtility.resetTimeout();
    const newErrors = {};
    Object.keys(formData).forEach((key) => {
      const error = validateField(key, formData[key], key);
      if (error) newErrors[key] = error;
    });
    if (
      !newErrors["account"] &&
      Journals.some((item) => item.account_id === formData.account.value)
    )
      newErrors["account"] = "This Account is already in the Journal Voucher!";
    if (
      !newErrors["type"] &&
      !newErrors["amount"] &&
      formData.type.value === 902 &&
      parseFloat(formData.amount) > parseFloat(formData.account.balance)
    )
      newErrors["amount"] = "Amount should be less than the account balance!";
    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      setLoadBtn(false);
      return;
    }

    const updatedItem = [...Journals];
    const newitem = {
      account_id: formData.account.value,
      account: formData.account.label,
      open_datetime: formData.account.open_datetime,
      amount: parseFloat(formData.amount),
      type_id: formData.type.value,
      type: formData.type.label,
      note: formData.notes,
    };
    setJournals([...updatedItem, newitem]);
    setFormData({
      account: "select",
      type: "select",
      amount: "0.0",
      notes: "",
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    TimeoutUtility.resetTimeout();
    setLoadBtn(true);

    if (Journals.length < 1) {
      showErrorToast("Error!", "Journal vouchar is empty.");
      setLoadBtn(false);
      return;
    }
    var a = 0,
      b = 0;
    Journals.forEach((element) => {
      a = a + (element.type_id === 902 ? parseFloat(element.amount) : 0);
      b = b + (element.type_id === 901 ? parseFloat(element.amount) : 0);
    });
    if (a !== b) {
      showErrorToast("Error!", "Credit and Debit are not equal!");
      setLoadBtn(false);
      return;
    }

    let ledgers = [];
    Journals.forEach((element) => {
      const newitem = {
        datetime: null,
        account_id: element.account_id,
        adjustment: element.amount,
        type_id: element.type_id,
        note: element.note,
      };
      ledgers.push(newitem);
    });
    try {
      const response = await addJournalApi(ledgers);
      if (response.success) {
        showSuccessToast("Success!", "Journal Ledger Added Successfully");
        navigate("/Journal");
      } else
        showErrorToast(
          "Error!",
          "Journal Ledger Failed to Add\n\n" + response.message,
        );
    } catch (err) {
      showErrorToast("Error!", "Journal Ledger Failed to Add");
    } finally {
      setLoadBtn(false);
    }
  };

  useEffect(() => {
    async function fetchData() {
      if (storeG?.store_id) {
        TimeoutUtility.resetTimeout();
        await getAccList(storeG.store_id)
          .then((resp) => {
            const accOptions = resp.data.map((item) => ({
              label: item.name,
              value: item.account_id,
              balance: item.balance,
              open_datetime: item.open_datetime,
            }));
            setAccounts(accOptions || []);
          })
          .catch((err) => console.log(err.message));
        setTypes([
          { label: "Credit", value: 902 },
          { label: "Debit", value: 901 },
        ]);
      }
    }
    fetchData();
  }, [storeG]);

  return (
    <div className="m-0 md:m-4 p-4 md:p-8 main-div-bg">
      <Header title="ADD JOURNAL" />
      <form>
        <Container className="g-0 form-container" fluid="true">
          <Row xs={1} sm={1} className="p-0 justify-content-center">
            <Col md={3} className="container-col">
              <div className="col-lg-12">
                <SelectField
                  label="Account:"
                  name="account"
                  value={formData.account}
                  options={Accounts}
                  onChange={handleSelectChange}
                  placeholder="Account"
                  compulsory={true}
                  error={errors.account}
                />
                <SelectField
                  label="Type:"
                  name="type"
                  value={formData.type}
                  options={Types}
                  onChange={handleSelectChange}
                  placeholder="Type"
                  compulsory={true}
                  error={errors.type}
                />
                <DoubleField
                  label="Amount:"
                  name="amount"
                  value={formData.amount}
                  onChange={handleChange}
                  placeholder="Amount"
                  min="0"
                  step="1.00"
                  compulsory={true}
                  error={errors.amount}
                />
                <TextAreaField
                  label="Notes:"
                  name="notes"
                  value={formData.notes}
                  onChange={handleChange}
                  placeholder="Notes"
                  error={errors.notes}
                />
                <div className="form-group p-3" style={{ textAlign: "center" }}>
                  <Button
                    text="Insert"
                    onClick={handleAddItem}
                    disabled={loadBtn}
                  />
                </div>
              </div>
            </Col>
            <Col md={2} className="container-col">
              <div className="col-lg-12">
                <div className="form-group mt-12">
                  <label className="label">
                    Bal: {formatCurrency(formData.account?.balance ?? 0)}
                  </label>
                </div>
              </div>
            </Col>
            <Col md={7} className="container-col">
              <GridComponent
                className="custom-grid"
                dataSource={Journals}
                height="calc(48vh - 60px)"
                allowSorting
                allowResizing
                recordDoubleClick={handleRowSelected}
                rowHeight={36}
              >
                <ColumnsDirective>
                  {customersGrid.map((item, index) => (
                    <ColumnDirective key={index} {...item} />
                  ))}
                </ColumnsDirective>
                <Inject services={[Resize, Sort]} />
              </GridComponent>
              <br />
              <br />
            </Col>
          </Row>
        </Container>
      </form>
      <Row md={"auto"} className="justify-content-center">
        <Button
          margin="10px"
          padding="20px"
          text="Add"
          onClick={handleSubmit}
          disabled={loadBtn}
        />
        <Button
          margin="10px"
          padding="20px"
          text="Back"
          onClick={handleBackClick}
        />
      </Row>
    </div>
  );
};

export default AddJournal;
